module.exports = __webpack_public_path__ + "static/img/IN.eb8fb35.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/countryFlag/IN.svg
// module id = TRJg
// module chunks = 66